import { render, staticRenderFns } from "./ActividadesDetalle.vue?vue&type=template&id=733cd4cf&scoped=true"
import script from "./ActividadesDetalle.vue?vue&type=script&lang=js"
export * from "./ActividadesDetalle.vue?vue&type=script&lang=js"
import style0 from "./ActividadesDetalle.vue?vue&type=style&index=0&id=733cd4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cd4cf",
  null
  
)

export default component.exports